import { useQuery } from '@tanstack/react-query';
import { useAppSelector } from 'store/hooks';
import { conciergeAPI } from 'api/concierge';
import { IDomain } from 'store/conciergeSlice';

export function useHasConciergeDomains(): { hasDomains: boolean; isLoading: boolean } {
    const conciergeEnabled = useAppSelector((state) => state.auth?.conciergeInfo?.enabled) ?? false;
    const showOn = useAppSelector((state) => state.auth?.conciergeInfo?.showOn);
    const isAdmin = useAppSelector((state) => state.auth?.userInfo?.isAdmin);
    const isPowerUser = useAppSelector((state) => state.auth?.userInfo?.isPowerUser);

    // Source availability is independent of where the icon is placed. Fetch whenever Concierge
    // is enabled and the icon can appear — admins/power users always see it (mirrors
    // useConciergeVisible), regular users only where a display scope is on.
    const isAnyEnabled = conciergeEnabled && (isAdmin || isPowerUser || showOn?.element || showOn?.catalog || false);

    const { data, isLoading } = useQuery<IDomain[]>({
        queryKey: ['conciergeDomains'],
        queryFn: () => conciergeAPI.getDomains(),
        enabled: isAnyEnabled,
        staleTime: 5 * 60 * 1000,
    });

    return {
        hasDomains: isLoading ? true : (data?.length ?? 0) > 0,
        isLoading,
    };
}
